module.exports = __webpack_public_path__ + "./static/img/update.46c8cf047e0ba0b1d48d6a7a42f92cb3.png";


//////////////////
// WEBPACK FOOTER
// ./client/src/assets/fontawesome/update.png
// module id = ./client/src/assets/fontawesome/update.png
// module chunks = 0